export const mutations = {
  addSite(state, site) {
    state.site = site
  },
  setSite(state, site) {
    state.site = site
  },
  addSites(state, site) {
    state.sites = [...site]
  },
  addSitePage(state, site){
    state.sites = site
  },
}
